import StaticConstants from "./Constants";
import Strings from "./StringSelector";

export default function Utils() {
  /*
    Returns the current height of the browser area that can render a page's content
    Offers support for older versions of Internet Explorer
  */
  this.getBrowserWindowHeight = function () {
    let windowHeight = 0;
    if (typeof (window.innerWidth) == "number") {
      //Non-IE
      windowHeight = window.innerHeight;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
      //IE 6+ in 'standards compliant mode'
      windowHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
      //IE 4 compatible
      windowHeight = document.body.clientHeight;
    }
    return (windowHeight);
  };

  // Returns description as an array, creating a new element everytime it finds ';'
  this.getLogDescriptionAsArray = function (logDescription) {
    let logArray = logDescription.split(";");
    return logArray;
  };

  // Returns description as an array, creating a new element everytime it finds '('
  this.getLogDescriptionThatContainsParenthesesAsArray = function (logDescription) {
    let logArray = logDescription.split("(");
    return logArray;
  };

  // Returns the description as an array
  // Each element of the array contains a substring of the description
  // with 36 or less characters
  this.getLongLogDescriptionAsArray = function (logDescription) {
    let logArray = [];
    const MAX_OF_DESCRIPTION_CHARACTERS_PER_LINE = 28;
    let numOfLines = Math.ceil(logDescription.length / MAX_OF_DESCRIPTION_CHARACTERS_PER_LINE);

    for (let i = 0; i < numOfLines; i++) {
      logArray[i] = logDescription.substr((i * MAX_OF_DESCRIPTION_CHARACTERS_PER_LINE), MAX_OF_DESCRIPTION_CHARACTERS_PER_LINE);
    }

    return logArray;
  };

  this.getLogNetworkStatusDescriptionAsArray = function (logDescription) {
    let logArray = logDescription.split(";");
    if (logArray.length > 1) {
      // We return only the first element to prevent cluttering the screen
      let newLogArray = [];
      newLogArray[0] = logArray[0] + "...";
      return newLogArray;
    } else {
      return logArray;
    }
  };

  // Checks if the POST configuration message was received succesfully by the backend
  this.checkStatus = async function (response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let errorText = await response.text();
      let error = new Error(errorText);
      error.response = response;
      throw error;
    }
  };

  // Parses the backend configuration response as a JSON
  // TODO: test removing this and putting it directly on the fetch
  this.parseJSON = function (response) {
    return response.json();
  };

  this.sortBy = function (field, reverse, primer) {

    let key = primer ?
      function (x) { return primer(x[field]); } :
      function (x) { return x[field]; };

    reverse = !reverse ? 1 : -1;

    return function (a, b) {
      // eslint-disable-next-line
      return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    };
  };

  // Returns the uppercase of a string only if it not null or undefined
  this.treatUppercase = function (str) {
    if (undefined !== str && null !== str) {
      return str.toUpperCase();
    } else {
      return " ";
    }
  };

  // Splits the IP strings only if they are not null or undefined
  this.treatSplitting = function (str) {
    if (undefined !== str && null !== str) {
      return str.split(".").map((num) => (`000${num}`).slice(-3)).join("");
    } else {
      return " ";
    }
  };

  this.validateIPAddress = function (ipAddress) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress)) {
      return true;
    }
    else {
      return false;
    }
  };

  this.validateSubnetworkIPAddress = function (ipAddress) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress)) {
      return true;
    }
    else {
      return false;
    }
  };

  this.validateSubmask = function (submask) {
    // eslint-disable-next-line
    let submaskRegex = new RegExp("^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$");
    return (submaskRegex.test(submask));
  };

  // Returns true if the IP is localhost (127.0.0.1)
  this.isIPLoopback = function (ipAddress) {
    if (ipAddress === "127.0.0.1") {
      return true;
    }
    else {
      return false;
    }
  };

  // Returns true if the IP is 0.0.0.0
  this.isZeroIP = function (ipAddress) {
    if (ipAddress === "0.0.0.0") {
      return true;
    }
    else {
      return false;
    }
  };

  this.validadeHostnameLength = function (hostname) {
    return (hostname.length >= 2) && (hostname.length <= 64);
  };

  // Hostname must start with a letter or a number, can have letters, numbers,
  // dot and hyphen, and must end with a letter or number
  // This validation is a simplification of the hostname regex, it is not perfect.
  // It allows for hostnames like: as...fg, which is not a valid hostname
  // However the the return of the webservice will say if the hostname was accepted or not
  this.simpleValidadeHostname = function (hostname) {
    const nameRegex = new RegExp("^[A-Za-z0-9][A-Za-z0-9/./-]*[A-Za-z0-9]$");
    return nameRegex.test(hostname);
  };

  // Adds a whitespace to strings that have more than 20 characters
  // and no whitespaces. The whitespace is inserted after every sequence
  // of 12 consecutive characters, the only exception being when it is the model
  // in the topology table. in this case the whitespace is inserted after every
  // 10 characters instead of 12.
  this.addWhitespaceToLongStrings = (str, isTopologyModel) => {
    const multiple = isTopologyModel ? 10 : 12;
    let multiplier = 0;

    if (!str.includes(" ") && str.length > 16) {
      let res = "";

      while ((multiple * multiplier) < str.length) {
        res = res.concat(str.substring(multiple * multiplier, multiple * (multiplier + 1)));
        res = res.concat(" ");
        multiplier++;
      }

      return res;
    }
    else if ((str.split(" ").length) === 2) {
      return str.replace(" ", "\n");
    }
    else {
      return str;
    }
  };

  this.getYesNoFromBoolean = (value) => {
    return value ? Strings.YES : Strings.NO;
  };

  this.getDRLCapability = (value) => {
    if (value !== "") {
      return value ? Strings.YES : Strings.NO;
    }
    else {
      return Strings.UNKNOWN;
    }
  };

  this.filterEmptyTendencyAndDuplicatedDevices = (devices) => {
    let newDevices = [];

    for (let i = 0; i < devices.length; i++) {
      if (devices[i].tendency !== undefined
        && devices[i].tendency !== null
        && devices[i].tendency.length > 8
        && !devices[i].isDuplicated) {

        newDevices.push(devices[i]);

      }
    }

    return newDevices;
  };

  this.hasMediaCountersIncrement = (mediaCounters) => {
    for (let i = 0; i < mediaCounters.length; i++) {
      // Só verifique devices que suportam media counters
      if (mediaCounters[i].media_counters_attr_supported === StaticConstants.ATTR_SUP_TRUE) {
        // Veja se alguma porta possui incremento de media counter
        for (let j = 0; j < mediaCounters[i].instances.length; j++) {
          if (mediaCounters[i].instances[j].has_media_counters_increment) {
            // Se possuir já retorne true
            return true;
          }
        }
      }
    }
    // Se nenhuma porta de nenhum device possuir incremento de media counter
    return false;
  };

  this.hasInterfaceCountersIncrement = (interfaceCounters) => {
    for (let i = 0; i < interfaceCounters.length; i++) {
      // Só verifique devices que suportam interface counters
      if (interfaceCounters[i].iface_counters_attr_supported === StaticConstants.ATTR_SUP_TRUE) {
        // Veja se alguma portas possui incremento de interface counters
        for (let j = 0; j < interfaceCounters[i].instances.length; j++) {
          if (interfaceCounters[i].instances[j].has_interface_counters_increment) {
            // Se possuir já retorne true
            return true;
          }
        }
      }
    }
    // Se nenhuma porta de nenhum device possuir incremento de interface counter
    return false;
  };

  /* Função para ajudar a escrever o blob no link de download */
  this.s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  };

  this.ipToBinary = (ip) => {
    return ip.split(".")
      .map(octet => parseInt(octet, 10).toString(2).padStart(8, "0"))
      .join(".");
  };

  this.calculateNetworkAddress = (ip, subnetMask) => {
    const ipBinary = this.ipToBinary(ip).split(".");
    const maskBinary = this.ipToBinary(subnetMask).split(".");
    const networkAddress = ipBinary.map((octet, index) => {
      return (parseInt(octet, 2) & parseInt(maskBinary[index], 2)).toString(2).padStart(8, "0");
    }).join(".");

    return networkAddress;
  };

  this.isSameNetwork = (ip1, ip2, subnetMask) => {
    const networkAddress1 = this.calculateNetworkAddress(ip1, subnetMask);
    const networkAddress2 = this.calculateNetworkAddress(ip2, subnetMask);
    return networkAddress1 === networkAddress2;
  };

  this.ipToInteger = (ip) => {
    return ip.split(".").reduce((int, octet) => (int << 8) + parseInt(octet, 10), 0);
  };

  this.calculateRange = (subnetIp, mask) => {
    const networkAddress = this.calculateNetworkAddress(subnetIp, mask);
    const invertedMask = mask.split(".").map(octet => 255 - parseInt(octet, 10)).join(".");
    const networkInt = this.ipToInteger(networkAddress.split(".").map(octet => parseInt(octet, 2).toString(10)).join("."));
    const broadcastInt = networkInt + this.ipToInteger(invertedMask);
    return [networkInt, broadcastInt];
  };

  this.subnetsOverlap = (subnetIp1, mask1, subnetIp2, mask2) => {
    const [range1Start, range1End] = this.calculateRange(subnetIp1, mask1);
    const [range2Start, range2End] = this.calculateRange(subnetIp2, mask2);
    return range1Start <= range2End && range2Start <= range1End;
  };

  // Funções para o cálculo de endereço de broadcast e endereço da rede
  this.ipToBinary2 = (ip) => {
    return ip.split(".").map(function (num) {
      return ("00000000" + parseInt(num, 10).toString(2)).slice(-8);
    }).join("");
  };

  this.binaryToIp = (binary) => {
    return binary.match(/.{1,8}/g).map(function (bin) {
      return parseInt(bin, 2).toString();
    }).join(".");
  };

  this.calculateNetworkAddress2 = (ipBinary, maskBinary) => {
    let networkBinary = "";
    for (let i = 0; i < 32; i++) {
      networkBinary += (ipBinary[i] === "1" && maskBinary[i] === "1") ? "1" : "0";
    }
    return networkBinary;
  };

  this.calculateBroadcastAddress = (networkBinary, maskBinary) => {
    let broadcastBinary = "";
    for (let i = 0; i < 32; i++) {
      broadcastBinary += (maskBinary[i] === "0") ? "1" : networkBinary[i];
    }
    return broadcastBinary;
  };

  this.isBroadcastAddress = (ip, subnetMask) => {
    const ipBinary = this.ipToBinary2(ip);
    const maskBinary = this.ipToBinary2(subnetMask);
    const networkBinary = this.calculateNetworkAddress2(ipBinary, maskBinary);
    const broadcastBinary = this.calculateBroadcastAddress(networkBinary, maskBinary);
    const broadcastAddress = this.binaryToIp(broadcastBinary);

    console.log("broadcastAddress: ", broadcastAddress);
    return ip === broadcastAddress;
  };

  this.isNetworkAddress = (ip, subnetMask) => {
    if (ip === "0.0.0.0") {
      return false;
    }

    const ipBinary = this.ipToBinary2(ip);
    const maskBinary = this.ipToBinary2(subnetMask);
    const networkBinary = this.calculateNetworkAddress2(ipBinary, maskBinary);
    const networkAddress = this.binaryToIp(networkBinary);

    console.log("networkAddress: ", networkAddress);
    return ip === networkAddress;
  };

  this.removeLeadingZeros = (fullIpAddress) => {
    if (fullIpAddress === "") {
      console.log("IP em branco, retorna IP em branco");
      return "";
    }
    else {
      let cleanedIp = fullIpAddress.split(".").map((ipPart) => {
        return parseInt(ipPart, 10);
      }).join(".");

      if (!this.validateIPAddress(cleanedIp)) {
        console.log("Caso de IP invalido, retorna o próprio texto passado como entrada");
        console.log("fullIpAddress", fullIpAddress);
        return fullIpAddress;
      }
      else {
        console.log("Caso de IP valido, retorna o IP sem os zeros à esquerda");
        console.log("cleanedIp", cleanedIp);
        return cleanedIp;
      }
    }
  };

  this.getLanguageStringFromKey = () => {
    let langKey = localStorage.getItem(StaticConstants.LOCAL_STORAGE_KEY);

    if (langKey === StaticConstants.ES_LANG_KEY) {
      return Strings.SPANISH;
    }
    else if (langKey === StaticConstants.EN_LANG_KEY) {
      return Strings.ENGLISH;
    }
    else {
      return Strings.PORTUGUESE;
    }
  };
}
